<template>
    <div class="login">
        <div class="content">
            <div class="content-layer"></div>
            <div class="header">
                <div class="logo">
                    <div class="title">
                        <h2 style="max-width: 600px;">АНАГААХ УХААНЫ ХҮРЭЭЛЭН</h2>
                        <p>ТАРХИНЫ ХАРВАЛТ БҮРТГЭЛ, СУДАЛГААНЫ СИСТЕМ</p>
                    </div>
                </div>

                <ul class="menu">
                    <li>
                        <a href="https://imsm.mn" target="_blank">
                           Үндсэн сайт
                        </a>
                    </li>
                </ul>
            </div>
            <div class="content-body">
                <div class="lottie">
                    <lottie-animation path="images/cms.json"/>
                </div>
            </div>

            <div class="footer">
                <h3>Системийн боломжууд</h3>
                <hooper :settings="hooperSettings">
                    <slide>
                        <div class="footer-item">
                            <a href="javascript:void(0)">
                                <inline-svg src="/assets/icons/duotone/General/Bank.svg"/>
                                <span>Бүртгэл мэдээлэл</span>
                            </a>
                        </div>
                    </slide>
                    <slide>
                        <div class="footer-item">
                            <a href="javascript:void(0)">
                                <inline-svg src="/assets/icons/duotone/Interface/Doughnut.svg"/>
                                <span>Мэдээлэл хяналт</span>
                            </a>
                        </div>
                    </slide>
                    <slide>
                        <div class="footer-item">
                            <a href="javascript:void(0)">
                                <inline-svg src="/assets/icons/duotone/Navigation/Route.svg"/>
                                <span>Бүртгэл тайлан</span>
                            </a>
                        </div>
                    </slide>
                    <slide>
                        <div class="footer-item">
                            <a href="javascript:void(0)">
                                <inline-svg src="/assets/icons/duotone/Electric/Air-conditioning.svg"/>
                                <span>Лог тайлан</span>
                            </a>
                        </div>
                    </slide>

                    <slide>
                        <div class="footer-item">
                            <a href="javascript:void(0)">
                                <inline-svg src="/assets/icons/duotone/Electric/Highvoltage.svg"/>
                                <span>Тохиргоо бүртгэл</span>
                            </a>
                        </div>
                    </slide>

                    <slide>
                        <div class="footer-item">
                            <a href="javascript:void(0)">
                                <inline-svg src="/assets/icons/duotone/Devices/Battery-full.svg"/>
                                <span>Бусад мэдээ мэдээлэл</span>
                            </a>
                        </div>
                    </slide>

                    <hooper-pagination slot="hooper-addons"></hooper-pagination>
                    <hooper-progress slot="hooper-addons"></hooper-progress>
                </hooper>
            </div>
        </div>

        <div class="auth">
            <div class="form-wrap">
                <router-view></router-view>
                <div class="copyright" v-html="copyright"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import iView from "iview";
import lang from "iview/dist/locale/en-US";
import vModal from "vue-js-modal";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import InlineSvg from 'vue-inline-svg';
import {
    Hooper, Slide, Pagination as HooperPagination,
    Navigation as HooperNavigation
} from 'hooper';

Vue.use(iView);
iView.locale(lang);
Vue.use(vModal, {componentName: "v-modal"});

export default {
    computed: {
        lang() {
            const labels = ['instructionsUse', 'frequentlyAskedQuestions', 'downloadAppHere', 'toContaqt', 'title', 'subtitle',];
            return labels.reduce((obj, key, i) => {
                obj[key] = this.$t('user.' + labels[i]);
                return obj;
            }, {});
        },
    },

    components: {
        LottieAnimation,
        Hooper,
        Slide,
        HooperPagination,
        HooperNavigation,
        InlineSvg
    },

    data() {
        return {
            isLoading: false,
            loading: false,
            isSuccess: false,
            isError: false,
            credentials: {
                login: null,
                password: null,
            },
            copyright: window.lambda.copyright,
            windowsd: window.lambda.windowslink,
            androidd: window.lambda.androidlink,

            lambda: window.lambda,
            faqs: [],
            help: null,
            hooperSettings: {
                itemsToShow: 6,
                breakpoints: {
                    800: {
                        centerMode: false,
                        itemsToShow: 2
                    },
                    1000: {
                        itemsToShow: 3,
                        pagination: 'fraction'
                    },
                    1300: {
                        itemsToShow: 5,
                        pagination: 'fraction'
                    },
                    1600: {
                        itemsToShow: 6,
                        pagination: 'fraction'
                    }
                }
            }
        };
    },

    mounted() {
    },
    created() {
    },
    methods: {
    },
};
</script>

<style lang="scss">
@import "./style.scss";
</style>
